// portraitCrop — the ONE framework-free source of truth for how a portrait
// VIDEO is cropped inside the center circle, shared by every renderer.
//
// BUG #927b: a portrait video must frame the subject IDENTICALLY on every
// surface — Discover/Gallery hover-preview (ExploreV2/VideoPortraitPreview),
// the live v1 View Wheel overlay (PortraitMedia/PortraitVideoOverlay), AND the
// strategic renderer-v2 wheel center media (renderer-v2/engine.js). A
// talking-head portrait is shot with the face near the top third of the source
// frame, so a dead-center 50%/50% cover crop (the CSS default) leaves too much
// headroom above the subject and can clip the chin; biasing the vertical anchor
// toward the top keeps the face in frame.
//
// WHY ITS OWN MODULE (not exported straight from PortraitVideoOverlay.jsx):
// renderer-v2/engine.js is deliberately framework-FREE (it also drives the
// embed web component, WL-036), so it must NOT import a React component module.
// These are plain string constants with no imports, so both the React tree and
// the vanilla-DOM engine can share the exact same values without React ever
// leaking into the embed bundle. Single source of truth, one crop window,
// every surface in lockstep.
export const PORTRAIT_VIDEO_OBJECT_FIT = "cover";
export const PORTRAIT_VIDEO_OBJECT_POSITION = "50% 20%";
